module.exports = function gigyaApi() {
	if (!window) {
		throw new Error('DOM is unavailable')
	}
	window.gigya = window.gigya || {}

	const gigya = document.getElementById('gigya')
	if (gigya) {
		// Prevent gigya to create root script if it already exists
		return window.gigya
	}
	const basicSRC = 'https://cdns.gigya.com/js/gigya.js?apikey='

	const script = document.createElement('script')
	script.type = 'text/javascript'
	script.id = 'gigya'
	script.defer = false
	script.src = `${basicSRC}${process.env.REACT_APP_GIGYA_API_KEY}`
	script.setAttribute('crossorigin', '*')

	const firstScriptTag = document.getElementsByTagName('script')[0]
	if (!firstScriptTag || !firstScriptTag.parentNode) {
		throw new Error('DOM is unavailable')
	}

	firstScriptTag.parentNode.insertBefore(script, firstScriptTag)
}
